import axios from "./axios"

const getDiscountCodes = async () => {
  return await axios.get("/admin/stripe_discount_codes")
}

const createDiscountCode = async ({ code, discount_percent }) => {
  const payload = { discount_percent }
  if (code) {
    payload.code = code
  }
  return await axios.post("/admin/stripe_discount_codes", payload)
}

const updateDiscountCode = async (id, { discount_percent, active }) => {
  const payload = {}
  if (discount_percent !== undefined) {
    payload.discount_percent = discount_percent
  }
  if (active !== undefined) {
    payload.active = active
  }
  return await axios.put(`/admin/stripe_discount_codes/${id}`, payload)
}

const deleteDiscountCode = async (id) => {
  return await axios.delete(`/admin/stripe_discount_codes/${id}`)
}

export default {
  getDiscountCodes,
  createDiscountCode,
  updateDiscountCode,
  deleteDiscountCode,
}
